export default {
  ScreenCommon: {
    CustomColorUnposted: 'Đổi màu chứng từ chưa ghi sổ',
    Selected: 'Đã chọn:',
    SelectedAll: 'Chọn tất',
    UnSelectedAll: 'Bỏ chọn',
    BatchExcution: 'Thực hiện hàng loạt',
    Filter: 'Lọc',
    Add: 'Thêm',
    Duplicate: 'Nhân bản',
    EditView: 'Xem/Sửa',
    PrintRecover: 'In phục hồi',
    DownloadVoucher: 'Tải chứng từ báo nợ',
    GenerateAccounting: 'Sinh hạch toán',
    GenerateVoucherBH: 'Sinh hạch toán lương, bảo hiểm',
    ChooseVoucher: 'Chọn mẫu chứng từ',
    View: 'Xem',
    ActionColumn: 'Chức năng',
    Delete: 'Xóa',
    All: 'Tất cả',
    Follow: 'Theo dõi',
    Unfollow: 'Ngừng theo dõi',
    Refresh: 'Lấy lại dữ liệu',
    Print: 'In',
    Help: 'Trợ giúp',
    Guide: 'Hướng dẫn',
    ImportExcel: 'Nhập khẩu từ Excel',
    Export: 'Xuất khẩu',
    Extention: 'Tiện ích',
    Address: 'Địa chỉ',
    Description: 'Diễn giải',
    Load: 'Nạp',
    NotPosted: 'Chưa ghi sổ',
    Posted: 'Ghi sổ',
    UnPosted: 'Bỏ ghi',
    ShortKeys: 'Phím tắt',
    Email: 'Email',
    CustomizeLayout: 'Tùy chỉnh giao diện',
    TotalAmount: 'Tổng tiền',
    GeneralInfo: 'Thông tin chung',
    EditKey: 'Sửa (Ctrl + E)',
    PostponeKey: 'Hoãn (Ctrl + U)',
    SaveKey: 'Cất (Ctrl + S)',
    CloseKey: 'Đóng (ESC)',
    CancelKey: 'Hủy',
    Accept: 'Đồng ý (Ctrl + S)',
    RefreshTooltip: 'Nạp (Ctrl + R)',
    Utilities: 'Tiện ích',
    FilterBtn: 'Áp dụng',
    Process: 'Quy trình',
    Report: 'Báo cáo',
    ViewAllReport: 'Xem tất cả báo cáo',
    Phone: 'Điện thoại',
    IdentityNumber: 'Số CMND',
    IdentityDate: 'Ngày cấp CMND',
    IdentityPlace: 'Nơi cấp',
    BudgetCode: 'Mã QHNS',
    Import: 'Nhập khẩu từ Excel',
    Increament: 'Ghi tăng',
    Decrement: 'Ghi giảm',
    Adjustment: 'Điều chỉnh',
    ViewVoucher: 'Xem chứng từ',
    AddVoucher: 'Thêm',
    AddVoucherTooltip: 'Thêm',
    Approve: 'Duyệt',
    UnApprove: 'Từ chối duyệt',
    VoucherNo: 'Số chứng từ',
    AccountingVoucher: 'Chứng từ hạch toán',
    SelectAccountingVoucher: 'Chọn chứng từ hạc toán',
    PrintTemplateAccount: 'In mẫu dự toán',
    PrintTemplateRecipe: 'In danh sách công thức',
    // Danh sách hoá đơn mua hàng
    ViewInvoice: 'Xem hoá đơn',
    CreateVoucher: 'Lập chứng từ',
    CreateVoucherFromInvoice: 'Lập chứng từ hạch toán',
    UnselectedVoucher: 'Bỏ chọn chứng từ đã hạch toán',
    SelectVoucher: 'Chọn Chứng từ đã hạch toán',

    SyncVoucherFromInbot: 'Cập nhật hoá đơn',
    NoAccounted: 'Không lập chứng từ',
    Edit: 'Sửa',
    Restore: 'Phục hồi',
    RestoreVoucherDeleted: 'Phục hồi dữ liệu đã xóa',
    RestoredVoucher: 'Đã phục hồi',
  },
  EventName: {
    Delete: 'Xóa',
    View: 'Xem',
    Save: 'Cất',
    Accept: 'Đồng ý',
    SaveAdd: 'Cất và thêm mới',
    SaveClose: 'Cất và đóng',
    SaveView: 'Cất và xem',
    Edit: 'Sửa',
    Close: 'Đóng',
    Duplicate: 'Nhân bản',
    Add: 'Thêm mới',
    Active: 'Theo dõi',
    Unactive: 'Ngừng theo dõi',
    Posted: 'Ghi sổ',
    UnPosted: 'Bỏ ghi',
    Ok: 'In báo cáo',
    ViewReport: 'Xem báo cáo',
    Postpone: 'Hoãn',
    // NextVoucher: 'Trước',
    // BackVoucher: 'Sau',
    NextVoucher: 'Sau',
    BackVoucher: 'Trước',
    Follow: 'Theo dõi',
    Unfollow: 'Ngừng theo dõi',
    NextStep: 'Tiếp tục',
    BackStep: 'Quay lại',
    SendApproval: 'Gửi duyệt',
    InsertRowGrid: 'Thêm dòng',
    DeleteRowGrid: 'Xóa dòng',
    Estimate: 'Nhập dự toán',
    Approve: 'Duyệt',
    Reject: 'Từ chối',
    UnApprove: 'Từ chối duyệt',
    SysRole: 'Phân quyền',
    SendNotify: 'Gửi thông báo cho khách hàng',
    SendInvoice: 'Gửi HĐ cho người mua',
    PublishInvoice: 'Phát hành HĐ',
    CreateSaleVoucher: 'Lập chứng từ bán hàng',
    ConvertToPaperVoucher: 'Chuyển thành HĐ giấy',
    DownloadInvoice: 'Tải HĐ',
    CancelInvoice: 'Hủy hóa đơn',
    SaleInvoiceReplace: 'Lập hóa đơn thay thế',
    CreateAdjustSaleInvoice: 'Lập hóa đơn điều chỉnh',
    PayTax: 'Nộp thuế',
    UpdateTaxIntoSalary: 'Cập nhật vào bảng lương',
    SalaryAllocation: 'Phân bổ nguồn',
    InvolveVoucher: 'Chứng từ liên quan',
    Cancel: 'Hủy',
    Load: 'Nạp',
    Stock: 'Nhập kho',
    Export: 'Xuất kho',
    Select: 'Chọn',
    Confirm: 'Xác nhận',
    BackToLogin: 'Quay lại đăng nhập',
    DownloadFile: 'Tải xuống',
    CreatVoucherInvoice: 'Lập chứng từ',
    UnChecked: 'Bỏ chọn',
    ChooseAll: 'Chọn tất cả',
  },
  ScreenName: {
    Login: 'Đăng nhập',
    BUTransfer: 'Chuyển khoản kho bạc',
    ToolList: 'Chứng từ liên quan',
    screenCode: 'Sao lưu dữ liệu',

    //#region Tổng quan
    Dashboard: 'Tổng quan',
    //#endregion

    //#region Danh sách
    BUReceiveBudgetPlan: 'Nhận dự toán',
    ToolIncrement: 'Ghi tăng CCDC',
    ToolDecrement: 'Ghi giảm CCDC',
    FAVoucherQLTSList: 'Danh sách chứng từ TSCĐ',

    //#endregion

    //#region Dự toán ngân sách
    BUPlanReceipt: 'Lập dự toán thu',
    BUPlanReceiptAddMLNS: 'DT thu theo MLNS',
    BUPlanReceiptAddTT342: 'DT thu theo NDKT TT342',
    BUPlanReceiptAddTT343: 'DT thu theo NDKT TT343',
    BUPlanReceiptAddTT344: 'DT thu theo NDKT TT344',
    BUPlanReceiptAdjustMLNS: 'Điều chỉnh dự toán thu theo Mục lục ngân sách',
    BUPlanReceiptAdjustTT342: 'Điều chỉnh dự toán thu theo NDKT (Mẫu TT 342/2016/TT-BTC)',
    BUPlanReceiptAdjustTT343: 'Điều chỉnh dự toán thu theo NDKT (Mẫu TT 343/2016/TT-BTC)',
    BUPlanReceiptAdjustTT344: 'Điều chỉnh dự toán thu theo NDKT (Mẫu TT 344/2016/TT-BTC)',
    BUPlanExpenseByBudget: 'DT chi theo MLNS',
    BUPlanExpenseByActivity342: 'DT chi theo NDKT TT342',
    BUPlanExpenseByActivity343: 'DT chi theo NDKT TT343',
    BUPlanExpenseByActivity344: 'DT chi theo NDKT TT344',
    BUPlanExpenseByActivityVt: 'DT chi theo NDKT Vũ Thư',
    BUPlanExpenseByBudgetSupplementAdjust: 'Điều chỉnh dự toán chi theo Mục lục ngân sách',
    BUPlanExpenseByActivitySupplementAdjust342: 'Điều chỉnh dự toán chi theo NDKT (Mẫu TT 342/2016/TT-BTC)',
    BUPlanExpenseByActivitySupplementAdjust343: 'Điều chỉnh dự toán chi theo NDKT (Mẫu TT 343/2016/TT-BTC)',
    BUPlanExpenseByActivitySupplementAdjust344: 'Điều chỉnh dự toán chi theo NDKT (Mẫu TT 344/2016/TT-BTC)',
    BUPlanExpenseByActivitySupplementAdjustVt: 'Điều chỉnh dự toán chi theo NDKT (Vũ Thư)',
    BUPlanAdjustmentDetail: 'Điều chỉnh dự toán',
    BUTreasuryWithdrawal: 'Phiếu rút tiền kho bạc',
    BUTransferDeposit: 'Chuyển khoản kho bạc vào tài khoản tiền gửi',
    BUBasicConstructionInvestment: 'Kế hoạch vốn đầu tư xây dựng cơ bản',
    //#endregion

    //#region
    CAPaymentDetail: 'Phiếu chi tiền',
    //#endregion

    //#region Vật tư, Công cụ dụng cụ
    ToolIncrementDetail: 'Phiếu ghi tăng CCDC',
    ToolDecrementDetail: 'Phiếu ghi giảm CCDC',
    //#endregion

    //#region Tổng hợp
    SUCreateReportDetail: 'Báo cáo tài chính',
    //#endregion

    //#region Danh mục
    DefaultAccount: 'Tài khoản ngầm định',
    BudgetItemDetail: 'Tiết tiểu mục',
    FixedAssetCategory: 'Loại tài sản cố định',
    //#endregion

    //#region Hệ thống
    //#region Nhập số dư ban đầu
    AccountBalance: 'Số dư tài khoản',
    BankAccountBalance: 'Số dư tài khoản ngân hàng',
    AccountingObjectBalance: 'Số dư theo đối tượng',
    InventoryMaterial: 'Tồn kho vật tư',
    OtherAccountBalance: 'Số dư tài khoản khác',
    //#endregion

    //#region Hệ thống
    ReSortRefNo: 'Sắp xếp lại số chứng từ',
    ResultConvert: 'Đối chiếu dữ liệu chuyển đổi',
    //#endregion

    //#region Thông tin chung
    QuickReport: 'Báo cáo nhanh',
    //#endregion

    //#endregion

    BUPlanAdjustCommit: 'Điều chỉnh cam kết chi',
    Dictionary: 'Danh mục',
    MLNS: 'Mục lục ngân sách',
    Etreasury: 'Nghiệp vụ kho bạc điện tử',
    BADeposit: 'Thu tiền gửi',
    BADepositDetail: 'Thu tiền gửi',
    BAWithDraw: 'Chi tiền gửi',
    BAInternalTransfer: 'Chuyển tiền nội bộ',
    BAAdvanceNSNN: 'Bảng kê nộp tiền NSNN',
    BUFinancialActivities: 'Kế hoạch thu chi các hoạt động tài chính khác',
    BUInvestmentPlanXDCB: 'Kế hoạch vốn đầu tư XDCB',
    BUInvestmentPlanXDCBDetail: 'Kế hoạch vốn đầu tư xây dựng cơ bản',
    BUPlanSummary: 'Tổng hợp dự toán',
    BUPlanSummaryReceiptMLNS: 'Tổng hợp DT thu theo MLNS',
    BUPlanSummaryReceiptTT342: 'Tổng hợp  DT thu theo NDKT TT342',
    BUPlanSummaryReceiptTT343: 'Tổng hợp  DT thu theo NDKT TT343',
    BUPlanSummaryReceiptTT344: 'Tổng hợp  DT thu theo NDKT TT344',
    BUPlanSummaryExpenseMLNS: 'Tổng hợp DT chi theo MLNS',
    BUPlanSummaryExpenseTT342: 'Tổng hợp  DT chi theo NDKT TT342',
    BUPlanSummaryExpenseTT343: 'Tổng hợp  DT chi theo NDKT TT343',
    BUPlanSummaryExpenseTT344: 'Tổng hợp  DT chi theo NDKT TT344',
    BUPlanSummaryExpenseTT344Vt: 'Tổng hợp  DT chi theo NDKT (Vũ Thư)',
    BUPlanTemplateExpense: 'Thiết lập chỉ tiêu chi',
    BUPlanTemplateExpenseTT342: 'Chỉ tiêu chi TT 342/2016/TT-BTC',
    BUPlanTemplateExpenseTT343: 'Chỉ tiêu chi TT 343, 344/2016/TT-BTC',
    BUPlanTemplateReceipt: 'Thiết lập chỉ tiêu thu',
    BUPlanTemplateReceiptTT342: 'Chỉ tiêu thu TT 342/2016/TT-BTC',
    BUPlanTemplateReceiptTT343: 'Chỉ tiêu thu TT 343, 344/2016/TT-BTC',
    BudgetPlan: 'Dự toán ngân sách',
    BUPlanReceive: 'Nhận dự toán',
    BUPlanReceiveAnnual: 'Nhận dự toán đầu năm',
    BUPlanReceiveSuppler: 'Nhận dự toán bổ sung',
    BUPlanReceiveAdjust: 'Điều chỉnh dự toán',
    Cash: 'Tiền mặt',
    Deposits: 'Tiền gửi',
    DIAccountingObjectCategory: 'Loại đối tượng',
    DIAccountingObject: 'Đối tượng',
    DIFund: 'Quỹ tiền',
    BUPlanTemplateReceipt: 'Thiết lập chỉ tiêu thu',
    DIDepartment: 'Phòng ban',
    FixedAssetList: 'Tài sản cố định',
    DIActivity: 'Hoạt động tài chính',
    DIBranch: 'Đơn vị trực thuộc',
    AccountingObject: 'Cán bộ',
    AccountingObjectList: 'Danh sách đối tượng',
    DIStatistic: 'Mã thống kê',
    DIContract: 'Hợp đồng',
    FAVoucherQLTS: 'Tài sản cố định',
    FAVoucherIncreament: 'Ghi tăng TSCĐ',
    FAVoucherDecrement: 'Ghi giảm TSCĐ',
    FAVoucherDepreciation: 'Hao mòn TSCĐ',
    FAVoucherAdjustment: 'Điều chỉnh TSCĐ',
    DIBudgetGroupItem: 'Nhóm mục chi',
    DIBudgetProvide: 'Mã dự phòng',
    DIBudgetSourceProperty: 'Tính chất nguồn kinh phí',
    SUGeneralVoucher: 'Chứng từ nghiệp vụ khác',
    SUGeneralParallel: 'Chứng từ ghi đồng thời',
    DIBudgetChapter: 'Chương',
    DIFundStructure: 'Nội dung chi phí',
    DIStock: 'Kho',
    DISalaryScale: 'Ngạch lương',
    DISalary: 'Lương',
    DIInventoryCategory: 'Loại vật tư/CCDC',
    DIEquipmentInventoryItem: 'Công cụ dụng cụ',
    DIHamlet: 'Thôn xóm',
    DIBankInfo: 'Tài khoản Ngân hàng, Kho bạc',
    DIActivityCategory: 'Loại hoạt động tài chính',
    CAAdjustReceipt: 'Điều chỉnh kinh phí thu',
    CAAdjustPayment: 'Điều chỉnh kinh phí chi',
    CACash: 'Phiếu thu',
    CAPayment: 'Phiếu chi',
    CAReceipt: 'Phiếu thu tiền',
    CAPaymentSalary: 'Phiếu chi trả lương',
    CAReceiptWithdraw: 'Phiếu rút tiền kho bạc',
    CAFundInventory: 'Kiểm kê quỹ tiền mặt',
    BUPlanAdjustment: 'Điều chỉnh kinh phí',
    BUPlanWdAdjustment: 'Điều chỉnh kinh phí',
    BUEnterCashFund: 'Nhập quỹ tiền mặt',
    BUCreateDeclareTable: 'Lập bảng kê',
    BUReceiptExpense: 'Bảng kê ghi thu - ghi chi',
    BUAdjustment: 'Điều chỉnh dự toán',
    BUPlanAdjustCommit: 'Điều chỉnh cam kết chi',
    BUPlanCancel: 'Hủy dự toán',
    BUPlanCommitExpense: 'Đề nghị cam kết chi',
    BUPlanExpense: 'Lập dự toán chi',
    BUBudgetReserve: 'Dự toán giữ lại',
    BUTransfer: 'Chuyển khoản kho bạc',
    DILocalBudgetItem: 'Khoản chi xã',
    DIInventoryItem: 'Vật tư',
    INTransfer: 'Chuyển kho',
    SUTransfer: 'Điều chuyển CCDC',
    INOutward: 'Xuất kho',
    INInward: 'Phiếu nhập kho',
    INInwardOther: 'Nhập khác',
    InventoryInwardCash: 'Nhập mua bằng tiền mặt',
    InventoryInwardDeposit: 'Nhập mua bằng tiền gửi',
    DIProject: 'Chương trình mục tiêu, dự án',
    DIAccessHistory: 'Nhật ký truy cập',

    DIOther: 'Khác',
    EReceipt: 'Biên lai',
    EReceiptDetail: 'Biên lai',
    EReceiptVoucherDetail: 'Phiếu thu tiền',
    EReceiptSummary: 'Bảng tổng hợp biên lai thu tiền',
    EReceiptSummaryDetail: 'Tổng hợp biên lai thu tiền',
    SUVoucherList: 'Tổng hợp chứng từ cùng loại',
    SURegisterList: 'Chứng từ ghi sổ',
    SUAccountTransfer: 'Phiếu kết chuyển tài khoản/ Quyết toán',
    SUAccountTransferDetail: 'Phiếu kết chuyển tài khoản',

    UserManagement: 'Quản lý người dùng',
    AdvancedSercurity: 'Bảo mật nâng cao',
    RoleManagement: 'Vai trò quyền hạn',
    SUCreateReport: 'Lập báo cáo',
    SUSubmitReport: 'Nộp báo cáo lên cấp trên',
    SULockLedger: 'Khóa sổ',
    RegimePosted: 'Chế độ ghi sổ',
    DefaultImplicitSetting: 'Thiết lập ngầm định',
    DIBankInfoCategory: 'Loại tài khoản Ngân hàng, Kho bạc',
    DIBank: 'Ngân hàng',
    AccountingObjectMaster: 'Danh sách đối tượng',
    BUPlanActivityTempSymmet: 'Thiết lập báo cáo cân đối',
    BUPlanTempReceiptReport: 'Thiết lập báo cáo thu',
    BUPlanTempExpenseReport: 'Thiết lập báo cáo chi',
    OPAccountBalance: 'Nhập số dư ban đầu',
    GetOPAccountBalance: 'Lấy số dư đầu năm',
    DISystemAccounts: 'Hệ thống tài khoản',
    DIAccountTransfer: 'Tài khoản kết chuyển',
    DIAutoBusiness: 'Định khoản tự động',
    DIAccountParallelRule: 'Quy tắc hạch toán đồng thời',
    DIBudgetKindItem: 'Loại/ khoản',
    DIBudgetItemSpend: 'Mục/ Tiểu mục chi',
    DIBudgetItemCollect: 'Mục/ Tiểu mục thu',
    DIBudgetSource: 'Nguồn kinh phí',
    SettingInitialInformationDeclaration: 'Khai báo thông tin ban đầu',
    SettingBusiness: 'Nghiệp vụ',
    SettingFormatNumber: 'Định dạng số',
    PrintReportSetting: 'Thiết lập in báo cáo',
    ConnectMisaApp: 'Kết nối phần mềm MISA',
    CompanyInfo: 'Thông tin đơn vị',
    InOutWard: 'Phiếu xuất kho',
    SUDecrementDetail: 'Phiếu ghi giảm CCDC',
    BUAdvancePaymentDetail: 'Bảng kê thanh toán tạm ứng',
    BUAdvanceExpenceDetail: 'Bảng kê chứng từ thực chi',
    DataManagement: 'Quản lý dữ liệu',
    BackupRestoreData: 'Sao lưu và phục hồi dữ liệu',
    Report: 'Báo cáo',
    SummaryProcess: 'Quy trình tổng hợp',
    SalaryProcess: 'Quy trình lương',
    FAVoucherProcees: 'Quy trình tài sản cố định',
    ToolsProcess: 'Quy trình vật tư, công cụ dụng cụ',
    ReceipProcess: 'Biên lai',
    DepositsProcess: 'Quy trình tiền gửi',
    CashProcess: 'Quy trình tiền mặt',
    PlanReceiptProcess: 'Quy trình dự toán ngân sách',
    EtreasuryProcess: 'Quy trình kho bạc điện tử',
    Dictionary: 'Danh mục',
    SaAccounting: 'Hạch toán chi phí lương, BH, KPCĐ',
    SaPayment: 'Chứng từ trả lương, bảo hiểm',
    VoucherSearch: 'Tìm kiếm chứng từ',
    DvcUser: 'Kho bạc điện tử',
    DvcFileList: 'Hồ sơ thanh toán',
    SettingFinancialReport: 'Thiết lập báo cáo tài chính',
    CheckFormular: 'Kiểm tra công thức',
    TreasuryCash: 'Rút dự toán tiền mặt',
    TreasuryTransfer: 'Rút dự toán chuyển khoản',
    TreasuryToAccountCash: 'Rút dự toán về tài khoản tiền gửi',
    TreasuryDepositsToCash: 'Rút tiền gửi Kho bạc về tiền mặt',
    SpendTransfer: 'Chi tiền gửi tại Kho bạc',
    AdvancePayment: 'Thanh toán tạm ứng',
    DvcInvestmentAdvance: 'Thanh toán tạm ứng vốn đầu tư',
    Adjustment: 'Nộp trả kinh phí',
    InvestmentWithTransfer: 'Rút vốn đầu tư bằng chuyển khoản',
    InvestmentWithCash: 'Rút vốn đầu tư bằng tiền mặt',
    CustomDetailTemplate: 'Tùy chỉnh mẫu',
    QuickReport: 'Báo cáo nhanh',
    // Hoá đơn inbot
    InbotInvoice: 'Hoá đơn đầu vào',
    InbotInvoiceList: 'Danh sách hoá đơn',
    DvcBudget: 'Kết nối DVC',
    DcsdFileList: 'Hồ sơ đối chiếu',
    ExpenseNormRegulation: 'Tiêu chuẩn định mức',

    RestoreVoucherList: 'Phục hồi dữ liệu đã xóa',

    ExaminationResultTabs: 'Kết quả kiểm tra',
    SettlementInstructions: 'Hướng dẫn quyết toán',
    UsefulKnowledge: 'Kiến thức hữu ích',
  },

  ButtonUtil: {
    Notifi: 'Thông báo',
    Dictionary: 'Danh mục',
    AddDictionary: 'Thêm mới Danh mục',
    DictionaryTab: {
      Chapter: 'Danh mục Chương',
      KindItem: 'Danh mục Loại khoản',
      Account: 'Thêm Cán bộ',
      Equipment: 'Thêm Công cụ dụng cụ',
      Object: 'Thêm Đối tượng',
      Activity: 'Thêm Hoạt động',
      Stock: 'Thêm Kho',
      Statistic: 'Thêm Mã thống kê',
      Department: 'Thêm Phòng ban',
      BankAccount: 'Thêm Tài khoản NH, KB',
      FixedAsset: 'Thêm Tài sản cố định',
      Inventory: 'Thêm Vật tư',
    },
    DuplicateVoucher: 'Thêm mới từ chứng từ hiện thời',
    DuplicateVoucher_2: 'Thêm mới từ chứng từ hiện thời',
    InitBalance: 'Nhập số dư ban đầu',
    CopyVoucher: 'Sao chép chứng từ',
    SUSubmitReport: 'Nộp báo cáo cấp trên',
    CreateAccountTransfer: 'Sinh phiếu kết chuyển tài khoản',
    CreateAccountDeposit: 'Sinh phiếu nộp tiền kho bạc',
    CreateAccountWithdrawal: 'Sinh phiếu rút tiền kho bạc',
    CreatePayment: 'Sinh phiếu chi',
    GeneratePaymentVoucher: 'Sinh phiếu chi',
    GenerateSalaryPayment: 'Sinh phiếu chi trả lương',
    GenerateSalaryDepositsPayment: 'Sinh phiếu chi tiền gửi trả lương',
    CreateReceipt: 'Sinh phiếu thu',
    SearchByDepartmentInfo: 'Tìm kiếm theo Mã phòng, Tên phòng',
    CreateOutward: 'Sinh phiếu xuất kho',
    GenerateExpenseAccounting: 'Sinh hạch toán chi phí lương, bảo hiểm, KPCĐ',
    GeneratePaymentVoucher: 'Sinh nhiều phiếu chi tiền',
    GenerateGroupOnePaymentVoucher: 'Sinh gộp một phiếu chi tiền',
  },

  FilterGrid: {
    FromDate: 'Từ ngày',
    ToDate: 'Đến ngày',
  },
};
